<template>
  <div class="ticket-product-list">
    <div class="header">
      <search
        @inputChange="inputChange"
        @placeCity="placeCity"
        :code="params.cityId"
        :city="city"
        :isAlpha="false"
        placeHoder="请输入景点名称"
        class="search_area"
      ></search> 
    </div>
    <div class="theme">
      <div
        class="item"
        v-for="item in $configs.scenic.themes"
        :key="item.value"
        @click="goToProductList(item.value)"
      >
        <van-image class="icon" :src="item.path" />
        <span>{{ item.text }}</span>
      </div>
    </div>

    <div class="advertising">
      <div class="title">
        <h3>当季好玩榜</h3>
        <span>大家都在看</span>
      </div>
      <div class="swiper">
        <ul class="swiper-list van-clearfix">
          <li
            v-for="(item, index) in advertisingList"
            :key="index"
            class="swiper-item"
            @click="onAdvertisingClick(item)"
          >
            <img :src="getFilePath(item.filePath)" mode="aspectFill" style="display:block;width:100%;height:100%;object-fit:cover"/>
            <!-- <img :src="getFilePath(item.filePath)" mode="aspectFill" style="display:block;width:100%;height:100%"/> -->
            <!-- <van-image fit="cover" :src="getFilePath(item.filePath)" /> -->
          </li>
        </ul>
      </div>
    </div>

    <div class="product-list">
      <van-tabs
        v-model="tabsActive"
        sticky
        line-height="0"
        :ellipsis="true"
        @click="onTabsChange"
      >
        <!-- <template v-for="item in $configs.scenic.tabs"> -->
        <template v-for="item in tabs">
          <van-tab
            v-if="item.name !== 3 || (item.name === 3 && !identityDeal)"
            :key="item.name"
            title-class="tab-style"
          >
            <template #title>
              <span v-if="item.name<3">{{item.title}}</span>
              <span v-else>{{item.title}} <img :src="item.img[item.index]" alt="" /></span>
            </template>
          </van-tab>
        </template>
      </van-tabs>
      <van-list
        v-model="loading"
        :finished="!loading && !hasMore"
        :finished-text="data.length > 0 ? '没有更多了' : ''"
        class="list"
        @load="fetchTicketProductList"
      >
        <TheScenicProductCard
          v-for="(item, index) in data"
          :key="index"
          :cardData="item"
        />
      </van-list>
      <van-empty v-if="!loading && data.length === 0" description="暂无产品" />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import Search from '../components/search.vue';
import TheScenicProductCard from './components/TheScenicProductCard';
import { getShareId } from '@/utils';
import { getOrgId } from '@/utils';

export default {
  name: 'scenicResourceList',
  components: {
    Search,
    TheScenicProductCard,
  },
  data() {
    return {
      // 广告列表
      advertisingList: [],
      // 标签页下标
      tabsActive: 0,
      tabs: [
        { title: '最新', name: 0 },
        { title: '推荐', name: 1 },
        { title: '热度', name: 2 },
        { title: '价格', name: 3, index: 0, img: [
          require("@/assets/icons/sort.png"),
          require("@/assets/icons/sort-high.png"),
          require("@/assets/icons/sort-low.png")
        ] },
      ],
    };
  },
  computed: {
    // 判断是否展示利润
    ...mapGetters(['identityDeal']),
    ...mapGetters('ticket/list', ['hasMore', 'priceMap', 'city']),
    ...mapState('ticket/list', ['initial', 'loading', 'data', 'params']),
  },
  created() {
    const { cardCouponNo } = this.$route.query;
    this.setCardCouponNo(cardCouponNo || '');
    this.setKeyWords("");
    // this.setCityId("");
    this.reload();
    this.getAdvertising();
    if (JSON.parse(sessionStorage.getItem('city'))) {
      this.setCityId(JSON.parse(sessionStorage.getItem('city'))[1].code)
    }
  },
  methods: {
    ...mapMutations('ticket/list', [
      'setThemes',
      'setSortFiled',
      'setSortType',
      'setKeyWords',
      'setCityId',
      'setCardCouponNo'
    ]),
    ...mapActions('ticket/list', ['fetchTicketProductList', 'reload']),
    // 搜索
    inputChange(value) {
      if (value !== undefined || value !== null) {
        this.setKeyWords(value);
        // this.reload();
      }
      this.$router.push({
        path: '/home/productList/ticketSearchList',
      });
    },
    placeCity(code) {
      this.setCityId(code);
      this.reload();
    },
    // 获取广告列表
    getAdvertising() {
      const params = {
        organizationId: this.$store.state.userInfo_v2.user?.tenantId,
        position: 'scenic_mid_hot',
      };
      this.$API.advertising.getAdvertisingList(params).then((res) => {
        this.advertisingList = (res.rows || []).filter(item => item.status!=='1');
      });
    },

    // 点击广告
    onAdvertisingClick(item = {}) {
      if (item.h5JumpUrl) {
        this.$router.push({
          path: item.h5JumpUrl,
          query: {
            shareId: getShareId(),
            tenantId: getOrgId(),
          },
        });
      }
    },

    goToProductList(theme) {
      if (theme) {
        this.setThemes([theme]);
      }
      this.$router.push({
        path: '/home/productList/ticketSearchList',
      });
    },

    // 切换产品筛选条件
    onTabsChange(active) {
      switch (active) {
        case 0: // 最新
          this.setSortFiled('5');
          this.setSortType('0');
          this.tabs[3].index = 0;
          break;
        case 1: // 推荐
          this.setSortFiled('4');
          this.setSortType('0');
          this.tabs[3].index = 0;
          break;
        case 2: // 热度
          this.setSortFiled('0');
          this.setSortType('0');
          this.tabs[3].index = 0;
          break;
        case 3: // 价格
          this.setSortFiled('2');
          if (!this.params.sortType || this.params.sortType == 0) {
            this.setSortType('1');
            this.tabs[3].index = 1;
          } else {
            this.setSortType('0')
            this.tabs[3].index = 2;
          }
          break;
      }
      this.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.ticket-product-list {
  box-sizing: border-box;

  /* 头部样式 */
  .header {
    padding: vw(24) vw(32);

    .search_area {
      height: vw(72);
      border-radius: vw(72);
    }
  }

  /* 分类菜单 */
  .theme {
    margin: vw(38) 0;
    padding: 0 vw(32);
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .item {
      width: vw(88);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .icon {
        width: vw(84);
        height: vw(84);
        margin-bottom: vw(30);
      }
      span {
        font-size: vw(22);
        text-align: center;
        width: 110%;
        display: inline-block;
      }
    }
  }

  /* 广告板块 */
  .advertising {
    .title {
      display: flex;
      align-items: center;
      overflow: hidden;
      padding: 0 vw(32);
      margin-bottom: vw(30);
      > h3 {
        min-width: 5em;
        font-size: vw(36);
        margin: 0;
      }
      > span {
        color: #999999;
        font-size: vw(24);
        margin-left: 1em;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .swiper {
      width: 100%;
      height: vw(400);
      overflow: hidden;
      > .swiper-list {
        white-space: nowrap;
        padding: 0 vw(32);
        padding-bottom: vw(10);
        overflow-x: scroll;
        > li {
          display: inline-block;
          width: vw(300);
          height: vw(400);
          margin-right: vw(32);
          border-radius: vw(8);
          overflow: hidden;
          ::v-deep .van-image {
            height: 100%;
          }
        }
      }
    }
  }

  /* 产品列表 */
  .product-list {
    padding: 0 vw(32);

    ::v-deep .van-tabs__wrap {
      height: vw(44);
      padding: vw(20) 0;
      margin-top: vw(20);
    }

    ::v-deep .tab-style {
      font-size: vw(28);
      line-height: 1.2;
      &.van-tab--active {
        // color: $theme-color;
        color: #00479C;
        font-weight: bolder;
      }
    }
  }
}
</style>
